import { auth } from "../firebase";
import { moduleColors, moduleIcons, base, obracore } from "../design/tokens";

function AppIcon({ icon }) {
  const config = moduleIcons[icon];
  const colors = moduleColors[icon];
  if (!config || !colors) return null;
  return (
    <div style={{
      width: 46, height: 46, borderRadius: 12,
      backgroundColor: colors.iconBg,
      display: "flex", alignItems: "center", justifyContent: "center",
      flexShrink: 0,
    }}>
      <svg width="22" height="22" viewBox={config.viewBox} fill="none"
        stroke={colors.iconStroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {config.paths?.map((d, i) => <path key={i} d={d} />)}
        {config.rects?.map((r, i) => <rect key={i} {...r} />)}
        {config.circles?.map((c, i) => <circle key={i} {...c} />)}
      </svg>
    </div>
  );
}

const statusStyles = {
  ok: { bg: "#f0fdf4", color: "#166534", dot: "#22c55e" },
  warn: { bg: "#fef9c3", color: "#92400e", dot: "#f59e0b" },
  crit: { bg: "#fef2f2", color: "#991b1b", dot: "#ef4444" },
};

export default function AppCard({ app, disabled, metrics }) {
  const colors = moduleColors[app.icon] || moduleColors.meetings;
  const st = statusStyles[metrics?.status] || statusStyles.ok;

  function handleClick() {
    if (disabled) return;
    const email = auth.currentUser?.email || "";
    const useSso = app.sso !== false;
    const separator = app.url.includes("?") ? "&" : "?";
    const url = useSso ? `${app.url}${separator}sso=1&email=${encodeURIComponent(email)}` : app.url;
    window.open(url, "_blank");
  }

  return (
    <div
      onClick={handleClick}
      style={{
        background: disabled ? "#fafafa" : "#fff",
        border: base.border,
        borderRadius: base.radius,
        padding: "16px 14px",
        transition: base.transition,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        gap: 18,
        fontFamily: obracore.font,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.boxShadow = base.shadow;
          e.currentTarget.style.transform = "translateY(-2px)";
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.transform = "none";
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          width: 4,
          background: disabled ? "#e2e8f0" : colors.accent,
        }}
      />

      <AppIcon icon={app.icon} />

      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 15,
            fontWeight: 700,
            color: "#1e293b",
            marginBottom: 4,
          }}
        >
          {app.name}
        </div>
        {metrics ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            <span style={{ fontSize: 12, color: "#64748b" }}>
              {metrics.line}
            </span>
            {metrics.statusText && (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                  fontSize: 10,
                  fontWeight: 700,
                  padding: "2px 8px",
                  borderRadius: 20,
                  background: st.bg,
                  color: st.color,
                }}
              >
                <span
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: st.dot,
                  }}
                />
                {metrics.statusText}
              </span>
            )}
          </div>
        ) : (
          <div style={{ fontSize: 12, color: "#94a3b8" }}>
            {app.description || ""}
          </div>
        )}
      </div>

      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#cbd5e1"
        strokeWidth="2"
        strokeLinecap="round"
        style={{ flexShrink: 0 }}
      >
        <path d="M9 18l6-6-6-6" />
      </svg>
    </div>
  );
}